import allFirstLevelObjectKeysAreNonNullable from '@stencil/hotels-utils/src/all-first-level-object-keys-are-nullable';

import {apiConfig} from '@stencil/hotels-config';
import megatron from '@stencil/megatron';

const {detailsAPIEndPoints} = apiConfig;

export interface HotelPolicyDataTypes {
  // crystal: boolean,
  additional_hotel_policy: {
    'Hotel Policy': Array<any>;
  };
  hotelPolicy: string[];
}

type ReturnType = [
  {
    hotelPolicyList: string[];
    additionalData: any;
  },
  Error,
];

const fetchHotelPolicy = async options => {
  const {checkin, checkout, pax, cityId, hotelCode, forwardParams, vendor} = options;

  if (!allFirstLevelObjectKeysAreNonNullable(options)) {
    return [
      {
        hotelPolicyList: [],
        additionalData: {},
      },
      new Error('Something Went Wrong While Fetching Hotel Policy. Please Try Refreshing'),
    ] as ReturnType;
  }

  const strQry = `hotels-${cityId}-${checkin}-${checkout}-${pax}`;

  const url = `/${
    detailsAPIEndPoints.hotelPolicy
  }&strQry=${strQry}&hc=${hotelCode}&fwdParams=${JSON.stringify(forwardParams)}&v=${vendor ||
    'v3'}`;

  let error: null | Error = null;

  let hotelPolicyData = {
    hotelPolicyList: [],
    additionalData: {},
  };

  try {
    const response = await megatron<null, HotelPolicyDataTypes>({
      name: 'cancellationPolicy',
      type: 'GET',
      url,
    });

    if (response) {
      hotelPolicyData = {
        ...hotelPolicyData,
        ...(response.hotelPolicy ? {hotelPolicyList: response.hotelPolicy} : {}),
        ...(response.additional_hotel_policy
          ? {additionalData: response.additional_hotel_policy}
          : {}),
      };
    }
  } catch (e) {
    error = e;
  }

  return [hotelPolicyData, error] as ReturnType;
};

export default fetchHotelPolicy;
